import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";

export const backend_url =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://api.bazzartecho.pakstreamers.cloud") ||
  "https://api.bazzartecho.pakstreamers.cloud";

const resolveCurrency = () => {
  if (typeof window === "undefined") return "Rs. ";
  return localStorage.getItem("store_currency") || "Rs. ";
};

export let currency = resolveCurrency();

export const setCurrency = (value) => {
  currency = value || "Rs. ";
  if (typeof window !== "undefined") {
    localStorage.setItem("store_currency", currency);
  }
};

function App() {
  return (
    <div>
      <Router>
        <AppRoutes />
      </Router>
    </div>
  );
}

export default App;
